import React, { Component } from "react";
import { withRouter } from "../../helpers/utility";
import { Container, Row, Col } from "reactstrap";
import { connect } from "react-redux";
import Search from "./HomeSearch/HomeSearch";
import Translate from "../../hoc/Locale/Translate";
import classes from "./Home.module.css";
import * as actions from "../../store/actions";
import Intro from "./Intro/Intro";
import Actions from "./Actions/Actions";
import Statistics from "./Statistics/Statistics";
import Logos from "./Logos/Logos";
import Publishers from "./Publishers/Publishers";
import PublishersFeatures from "./PublishersFeatures/PublishersFeatures";
import Pricing from "./Pricing/Pricing";
import PricingDetails from "./PricingDetails/PricingDetails";
import PublisherParticipation from "./PublisherParticipation/PublisherParticipation";
import BrochureDownload from "./BrochureDownload/BrochureDownload";
import FontAwesome from "react-fontawesome";
import PropTypes from "prop-types";
import DeleteUserProfileBanner from "../UI/DeleteUserProfileBanner/DeleteUserProfileBanner";
import StatusEmbedLoader from "./StatusEmbedLoader/StatusEmbedLoader";
// import StatuspageWidget from "./StatuspageWidget/StatuspageWidget";

class Home extends Component {
  constructor(props) {
    super(props);
    this.vortieleHashed = React.createRef();
    this.preiseHashed = React.createRef();
    this.teilnehmenHashed = React.createRef();
  }
  

  componentDidMount() {
    this.props.onFetchPortalStatus();
    //  this.statusScript = document.createElement("script");
    // this.statusScript.src = "https://status-portal.de/embed/script.js";
    // this.statusScript.async = true;
    // document.body.appendChild(this.statusScript);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props.router;

    if(location && location.hash) {
      if(location.hash === "#vorteile") {
      this.vortieleHashed.current.scrollIntoView();
      } else if(location.hash === "#preise") {
        this.preiseHashed.current.scrollIntoView();
      } else if(location.hash === "#teilnehmen") {
        this.teilnehmenHashed.current.scrollIntoView();
      }
    }
  }
  //  componentWillUnmount() {
  //   if (this.statusScript) {
  //     document.body.removeChild(this.statusScript);
  //   }
  // }

  render() {
    const {
      appLanguage,
      isAuthenticated,
      portalStatus,
      portalMessageSpecial,
      showDeleteUserMessage,
      onHideDeleteUserMessage
    } = this.props;

 
  if (showDeleteUserMessage && !isAuthenticated) {
    setTimeout(() => {
    onHideDeleteUserMessage();
    }, 2000)
  }

    return (
      <div>
        <div className={classes.Main}>
         {showDeleteUserMessage && !isAuthenticated &&(
              <DeleteUserProfileBanner
              appLanguage={appLanguage}
              />
            )}
          <div className={classes.TextSection}>
            {portalMessageSpecial && portalMessageSpecial.id !== 0 && (
              <div className={classes.CampaignContainer}>
                <span className={classes.SpecialCampaign}>
                  {portalMessageSpecial.nachricht}
                </span>
              </div>
                    )}
            <Intro />
            <Actions
              isAuthenticated={isAuthenticated}
              appLanguage={appLanguage}
              redirectToJobBuilder={this.redirectToJobBuilder}
              redirectToLogin={this.redirectToLogin}
              redirectToRegistration={this.redirectToRegistration}
            />
          </div>
          <div>
            <div className={classes.Search}>
              <Container>
                <Row>
                  <Col sm="1" md="3"></Col>
                  <Col sm="10" md="6">
                    <Search
                      appLanguage={appLanguage}
                      handleSubmit={this.searchHandler}
                    />
                  </Col>
                  <Col sm="1" md="3"></Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <Statistics
                      portalStatus={portalStatus}
                      appLanguage={appLanguage}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col sm="12">&nbsp;</Col>
                </Row>
                <Row>
                  <Col sm="12">&nbsp;</Col>
                </Row>
                <Row>
                  <Col sm="12">&nbsp;</Col>
                </Row>
                <Row>
                  <Col sm="12">
                    <div>
                      <div className={classes.LogosHint}>
                        <Translate id="Home.Logos.Hint" />
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </div>
          </div>
          <div className={classes.LogosSection}>
            <Logos />
            <div></div>
          </div>
        </div>
        <div
          id="vorteile"
          ref={this.vortieleHashed}
          className={[classes.TextSection, classes.VorteileSection].join(" ")}
        >
          <div>
            <h3 className={classes.Header}>
              <FontAwesome name="plus-circle" /> &nbsp;
              <Translate id="Home.Vorteile" />
            </h3>
          </div>
        </div>
        <div className={[classes.TextSection, classes.VerlagSection].join(" ")}>
          <Publishers />
        </div>
        <div>
          <PublishersFeatures />
        </div>
        <div
          id="preise"
          ref={this.preiseHashed}
          className={[classes.TextSection, classes.PricingSection].join(" ")}
        >
          <Pricing />
        </div>
        <div>
          <div className={classes.TriangleDiv}>
            <div className={[classes.TriangleDown].join(" ")}></div>
          </div>
        </div>
        <div className={classes.Prices}>
          <PricingDetails headerText="Home.Pricing.Column1.HeaderText" header="Home.Pricing.Column1.Header" text="Home.Pricing.Column1.Text" subtext="Home.Pricing.Column1.SubText" />
          <PricingDetails headerText="Home.Pricing.Column2.HeaderText" header="Home.Pricing.Column2.Header" text="Home.Pricing.Column2.Text" subtext="Home.Pricing.Column2.SubText"/>
        </div>
        <div
          id="teilnehmen"
          ref={this.teilnehmenHashed}
          className={[classes.TextSection, classes.PricingSection].join(" ")}
        >
          <PublisherParticipation />
        </div>
        <div
          className={[classes.TextSection, classes.BrochureSection].join(" ")}
        >
          <BrochureDownload />
        </div>
        {/*         <div>
          <HomeDescription />
        </div>
        <div>
          <PublishersCarousel />
        </div> */}
        
         {/* <StatuspageWidget pageId="zv7r9jf6v0g6" /> */}
         <StatusEmbedLoader />
      </div>
    );
  }

  searchHandler = mediaTitle => {
    const queryString = encodeURIComponent(mediaTitle);

    this.props.navigation({
      pathname: "medien",
      search: mediaTitle ? "?name=" + queryString : null,
      state: {
        Suchbegriff: queryString
      }
    });
  };

  redirectToLogin = () => {
    this.props.navigation("/auth");
  };

  redirectToRegistration = () => {
    this.props.navigation("/register");
  };

  redirectToJobBuilder = () => {
    this.props.navigation("/jobs/neu-job");
  };
}


Home.propTypes = {
  appLanguage: PropTypes.string,
  isAuthenticated: PropTypes.bool,
  portalStatus: PropTypes.object,
  portalMessageSpecial: PropTypes.object,
  showDeleteUserMessage: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    isAuthenticated: state.auth.token !== null,
    appLanguage: state.auth.appLanguage,
    portalStatus: state.auth.portalStatus,
    portalMessageSpecial: state.auth.portalMessageSpecial,
    showDeleteUserMessage: state.auth.showDeleteUserMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onFetchPortalStatus: () => dispatch(actions.fetchPortalStatus()),
    onHideDeleteUserMessage: () => dispatch(actions.hideDeleteUserMessage())
  };
};

export { Home };
export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Home)
);
